export default {
  workspace: "Aho Umunyamuryango Akorera",
  selectedGroup: "Itsinda Ryahiswemo",
  userFallback: "Ukoresha Sisitemu",
  welcome: "Murakaza neza, {name}",
  roleLabel: "Inshingano",
  secureOtp: "Kwinjira mu Mutekano ukoresheje OTP",

  actions: {
    openMenu: "Fungura meni",
    closeMenu: "Funga meni",
    logout: "Sohoka",
  },

  roles: {
    owner: "Nyir’Itsinda",
    admin: "Umuyobozi",
    treasurer: "Umubitsi",
    member: "Umunyamuryango",
  },

  admin: {
    section: "Ubuyobozi",
    panel: "Aho Ubuyobozi Bukorera",
  },

  menu: {
    sections: {
      overview: "Incamake",
      savings: "Ubwizigame",
      loans: "Inguzanyo",
      account: "Konti",
    },

    items: {
      dashboard: "Ahabanza",
      statement: "Inyandiko y’Imari",
      contributions: "Imisanzu",
      loans: "Inguzanyo",
      penalties: "Ibihano",
      loan_applications: "Ubusabe bw’Inguzanyo",
      withdrawals: "Kubikuza",
      profile: "Umwirondoro",
    },
  },
};
